import React from "react";

const ProfileBio = ({ bio, editing, onChange }) => {
  return editing ? (
    <textarea
      value={bio}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Enter your bio"
      style={{
        width: "100%",
        padding: "10px",
        marginBottom: "10px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        resize: "none",
        minHeight: "50px",
      }}
    />
  ) : (
    <p style={{ color: "#dbd9d1", marginBottom: "20px", textAlign: "center" }}>
      {bio || "No bio available."}
    </p>
  );
};

export default ProfileBio;
